module.exports = __webpack_public_path__ + "img/for_who_1_tablet.33fad10.jpg";